import { render } from "./BusinessStatus.vue?vue&type=template&id=59e6872a&scoped=true"
import script from "./BusinessStatus.vue?vue&type=script&lang=js"
export * from "./BusinessStatus.vue?vue&type=script&lang=js"

import "./BusinessStatus.vue?vue&type=style&index=0&id=59e6872a&lang=scss&scoped=true"

import exportComponent from "/builds/engineering/loans-and-lines/commercial-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e6872a"]])

export default __exports__